import { Injectable } from '@angular/core';
import { WindowHelperService } from '@anecdotes/utils';
import { continuePathQueryParam, isSessionExpiredQueryParam } from '../../constants';
import { TenantSubDomainExtractorService } from '../tenant-sub-domain-extractor/tenant-sub-domain-extractor.service';

@Injectable()
export class AuthNavigatorService {
  constructor(private windowHelper: WindowHelperService, private tenantSubDomainExtractorService: TenantSubDomainExtractorService) {}

  redirectToSignIn(
    queryParams: {
      [continuePathQueryParam]?: string;
      [isSessionExpiredQueryParam]?: boolean;
    } = undefined
  ): void {
    const url = this.tenantSubDomainExtractorService.getTenantSignInUrl(queryParams);
    this.windowHelper.openUrl(url);
  }
}
